import React from 'react'
import { Form } from 'react-bootstrap'
import { toothSurfaceOptions } from './constants'

const ToothSurfaces = ({
  selectedTooth,
  selectedTeeth = [],
  treatmentForm,
  onSurfaceChange,
  onToothClick,
  onToothZoneClick,
}) => {
  const toothList = selectedTeeth.length
    ? selectedTeeth
    : selectedTooth
    ? [selectedTooth]
    : []
  const toothZones = treatmentForm.toothZones || []
  const hasSelectedToothZones = toothZones.length > 0
  const isDisabled = !toothList.length
  const surfaceMap = treatmentForm.toothSurfaceMap || {}

  if (hasSelectedToothZones) {
    return (
      <Form.Group className="mb-3">
        <Form.Label className="my-2">พื้นที่รักษา</Form.Label>
        <div className="d-flex flex-wrap">
          {toothZones.map((toothZone, toothZoneIndex) => {
            const toothZoneKey = String(
              toothZone.id || toothZone.toothZoneId || toothZoneIndex,
            )
            const toothZoneLabel =
              toothZone.toothZoneLabel || toothZone.label || ''
            const dentitionLabel =
              toothZone.dentition === 'child' ? 'ฟันเด็ก' : 'ฟันผู้ใหญ่'
            const toothList = toothZone.toothList || []
            const toothCount = toothList.length
            const toothListLabel = toothList.join(', ')

            return (
              <div
                key={toothZoneKey}
                className="d-flex align-items-center border rounded px-3 py-2 mr-2 mb-2"
                style={{ backgroundColor: '#f8fbff', borderColor: '#b9d7ff' }}
              >
                <button
                  type="button"
                  className="btn btn-link text-danger p-0 mr-3"
                  aria-label={`ลบพื้นที่ ${toothZoneLabel}`}
                  onClick={() => onToothZoneClick(toothZone)}
                >
                  <i className="feather icon-trash-2" aria-hidden="true" />
                </button>
                <div>
                  <div className="font-weight-bold">
                    {toothZoneLabel} - {dentitionLabel}
                  </div>
                  <small className="text-muted">
                    ครอบคลุม {toothCount} ซี่
                  </small>
                  {toothListLabel ? (
                    <small
                      className="d-block text-muted mt-1"
                      style={{ lineHeight: 1.5 }}
                    >
                      <span className="font-weight-bold">ซี่ฟัน:</span>{' '}
                      {toothListLabel}
                    </small>
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      </Form.Group>
    )
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label className="my-2 mr-2">ซี่ฟัน</Form.Label>

      {!!toothList.length && (
        <div className="mt-2">
          {toothList.map((tooth, toothIndex) => {
            const toothKey = String(tooth.fdi || toothIndex)
            const toothLabel = tooth.fdi ? `${tooth.fdi} - ${tooth.name}` : ''
            const toothSurfaces =
              surfaceMap[toothKey] ||
              (String(treatmentForm.fdi) === toothKey
                ? treatmentForm.toothSurfaces || []
                : [])

            return (
              <div
                key={toothKey}
                className="d-flex flex-wrap align-items-center mb-2"
              >
                <div
                  className="d-flex align-items-center mb-2 mr-3"
                  style={{ minWidth: 220 }}
                >
                  {tooth.fdi && (
                    <i
                      className="feather icon-trash-2 text-danger mr-2"
                      role="button"
                      style={{ cursor: 'pointer', fontSize: 22 }}
                      onClick={() => onToothClick(tooth)}
                    />
                  )}
                  <Form.Label
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: '16px' }}
                  >
                    {toothLabel}
                  </Form.Label>
                </div>
                <div className="d-flex flex-wrap">
                  {toothSurfaceOptions.map((surface) => {
                    const inputId = `tooth-surface-${toothKey}-${surface.value}`

                    return (
                      <div
                        key={surface.value}
                        className="d-flex align-items-center mr-3 mb-2"
                      >
                        <Form.Control
                          id={inputId}
                          type="checkbox"
                          checked={
                            toothSurfaces.includes(surface.value) ||
                            toothSurfaces.includes(surface.legacyValue)
                          }
                          disabled={isDisabled}
                          onChange={(event) =>
                            onSurfaceChange(
                              tooth,
                              surface,
                              event.target.checked,
                            )
                          }
                          style={{
                            width: 20,
                            height: 20,
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <Form.Label
                          htmlFor={inputId}
                          className="mb-0 ml-2"
                          style={{
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                          }}
                        >
                          {surface.label}
                        </Form.Label>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </Form.Group>
  )
}

export default ToothSurfaces
